import {
  Box,
  RadioButton,
  RadioButtonGroup,
  Typography,
} from "@bca/ui-library";
import React from "react";
import styled, { css } from "styled-components";
import SortOption from "../Interfaces/SortOption";

const Container = styled(Box)`
  ${css({
    border: "normalBorder",
    color: "grey-blue",
  })}
`;

interface SortOptionsMobileProps {
  selectedSortOption: string;
  setSelectedSortOption: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sortOptions: SortOption[];
}

const SortOptionsMobile: React.FunctionComponent<SortOptionsMobileProps> = ({
  selectedSortOption,
  setSelectedSortOption,
  sortOptions,
}) => {
  const onSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedSortOption(event);
  };
  return (
    <Container
      as="aside"
      width="100%"
      maxWidth={210}
      mr={5}
      mt={20}
      flexDirection="column"
      display="flex"
    >
      <Box marginBottom="15px">
        <Typography variant="h6" m={0}>
          Sort By
        </Typography>
      </Box>
      <RadioButtonGroup
        name="sort-options"
        onChange={onSelect}
        orientation="vertical"
        value={selectedSortOption}
      >
        {sortOptions?.map((sortOption: SortOption) => (
          <RadioButton
            key={sortOption.key}
            label={sortOption.label}
            value={sortOption.key}
          />
        ))}
      </RadioButtonGroup>
    </Container>
  );
};

export default SortOptionsMobile;
